// extracted by mini-css-extract-plugin
module.exports = {"parallax":"ParallaxSection_parallax__xDNn0","background":"ParallaxSection_background__yCI0Q","foreground":"ParallaxSection_foreground__J1MYm"};